import { faBuilding } from '@fortawesome/pro-solid-svg-icons';
import { useTheme } from '@material-ui/core';
import ButtonBase from '@material-ui/core/ButtonBase';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { HalfCircle } from 'commons/HalfCircle/HalfCircle';
import LocalizedText from 'commons/LocalizedText/LocalizedText';
import useMobile from 'hook/UseMobile';
import React from 'react';

const purpleMain = '#692984';

const useStyles = makeStyles((theme) => ({
  root: {
    cursor: 'pointer',
    display: 'flex',
    width: 430,
    minHeight: 160,
    margin: 10,
    boxShadow: theme.palette.shadow.card,
    transition: '0.3s',
    '&:hover': {
      transform: 'translateY(-3px)',
      boxShadow: theme.palette.shadow.hover
    },
    padding: 0
  },
  buttonBase: {
    display: 'contents',
    width: '100%'
  },
  cardContent: {
    minHeight: 140,
    textAlign: 'left'
  },
  testsTotal: {
    marginTop: theme.spacing(3)
  },
  content: {
    margin: 0,
    marginTop: theme.spacing(1),
    padding: 0,
    width: '100%',
    color: theme.palette.text.secondary
  },
  laboratory: {
    fontWeight: '700'
  },
  iconMobile: {
    color: purpleMain,
    marginTop: '60px',
    marginLeft: '7px'
  },
  icon: {
    color: purpleMain,
    marginTop: '65px',
    marginLeft: '15px'
  }
}));

export default function LaboratoryCard({ laboratory, onClick }) {
  const classes = useStyles();
  const isMobile = useMobile();
  const theme = useTheme();
  const iconStyle = isMobile ? classes.iconMobile : classes.icon;

  return (
    <Card className={classes.root} onClick={onClick}>
      <ButtonBase className={classes.buttonBase}>
        <HalfCircle backgroundColor={theme.palette.grey.A100} height={isMobile ? 40 : 60}
          icon={faBuilding} iconStyle={iconStyle} size={"2x"} width={isMobile ? 20 : 40} withIcon={true}/>
        <CardContent className={classes.cardContent}>
          <Typography className={classes.laboratory} component="h5" variant="h6">
            {laboratory.name} ({laboratory.companyNumber})
          </Typography>
          <Typography className={classes.testsTotal} variant="h6">
            <LocalizedText text="orderedTests" />
            {`: ${laboratory.testsOrdered}`}
          </Typography>
        </CardContent>
      </ButtonBase>
    </Card>
  );
}